<ng-template #defaultGroupHeaderTemplate let-groupItem>
  <ggx-group-selection-header
    [dataItem]="groupItem"
    [fieldName]="groupLabel() || field"
    (groupSelectChecked)="groupSelectChecked.emit($event)"
  ></ggx-group-selection-header>
</ng-template>

<ng-template #defaultHeaderTemplate let-column>
  <span title="{{ column.title }}">{{ column.title }}</span>
</ng-template>

<ng-template #defaultCellTemplate let-dataItem="dataItem">
  <span title="{{ dataItem[field] }}">{{ dataItem[field] }}</span>
</ng-template>

<ng-template
  #defaultFilterMenuTemplate
  let-filter
  let-menuColumn="column"
  let-filterService="filterService"
>
  <kendo-grid-string-filter-menu
    [column]="menuColumn"
    [filter]="filter"
    [filterService]="filterService"
  >
    <kendo-filter-eq-operator></kendo-filter-eq-operator>
    <kendo-filter-neq-operator></kendo-filter-neq-operator>
    <kendo-filter-contains-operator></kendo-filter-contains-operator>
    <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
    <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
    <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
  </kendo-grid-string-filter-menu>
</ng-template>
